export const Steps = {
    Personalise: 0,
    AddRecipientsOptions: 1,
    AddRecipientsManual: 2,
    AddRecipientsCsv: 3,
    Delivery: 4,
    DonationSelect: 5,
};
